import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(undefined, async (error) => {
  const config = error.config;
  if (!error.response && config && !config.__retried && config.url && config.url.startsWith("/auth/")) {
    config.__retried = true;
    await new Promise((r) => setTimeout(r, 2000));
    return api(config);
  }
  return Promise.reject(error);
});

export function formatApiError(error, t) {
  if (!error?.response) return t ? t("common.networkError") : "Network Error";
  const detail = error.response.data?.detail;
  if (detail == null) return error?.message || "Error";
  if (detail === "Failed to send email") return t ? t("auth.resetSendError") : detail;
  if (detail === "Incorrect password") return t ? t("profile.deleteWrongPassword") : detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
